import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Justification } from '../models/justification.js';
import { createJustificationEndpoint } from './const';

export const createJustification = (justification: Justification) => {
    return getHttpClient().post({ url: createJustificationEndpoint, data: JSON.stringify(justification) });
};
